var map = {
	"./ColapseBrancoFechar.svg": 1221,
	"./Mask.svg": 170,
	"./Trash.svg": 171,
	"./Vector.png": 1222,
	"./Vector.svg": 169,
	"./abrir-menu-mobile.svg": 1223,
	"./abrir-menu-mobile_custom.svg": 1224,
	"./abrir-modal.svg": 1225,
	"./adicionar.svg": 176,
	"./agenda-menu-mobile.svg": 1226,
	"./alerta-acao-preparatoria.svg": 462,
	"./alerta-cancelar-tema-IA.svg": 287,
	"./angle-down.svg": 1227,
	"./aniversario-parlamentar.svg": 253,
	"./arquivo.svg": 1228,
	"./audio-discurso.svg": 1229,
	"./audio_icon.svg": 1230,
	"./author.png": 1231,
	"./avatar-parlamentar.png": 77,
	"./aviso-vermelho.svg": 299,
	"./bitmap.png": 1232,
	"./bitmap@2x.png": 1233,
	"./bitmap@3x.png": 1234,
	"./bradesco-logo.png": 1235,
	"./bradesco/clips-vermelho.svg": 1236,
	"./bradesco/colapseVermelhoAbrir.svg": 1237,
	"./bradesco/colapseVermelhoFechar.svg": 1238,
	"./bradesco/link-externo-vermelho.svg": 1239,
	"./bradesco/logo-bradesco-login.svg": 1240,
	"./bradesco/seta-biografia-vermelha.svg": 1241,
	"./brasilia-img.jpg": 1242,
	"./brasilia-img.png": 1243,
	"./brasilia-img.svg": 1244,
	"./bt-fechar.svg": 1245,
	"./btn_limpar.svg": 111,
	"./btn_pesquisar.svg": 110,
	"./cielo/login-illustra.png": 1246,
	"./cielo/tela_login_sm.png": 1247,
	"./citacoes-menu.svg": 380,
	"./classBranco.svg": 387,
	"./classificacaotemasMenu.svg": 1248,
	"./clips-red.svg": 1249,
	"./colapseBranco.svg": 1250,
	"./config.png": 458,
	"./create_24px_outlined.svg": 1251,
	"./diskSave.svg": 133,
	"./diskSaveWhite.svg": 204,
	"./dislike.svg": 1252,
	"./down-arrow.svg": 1253,
	"./edit.svg": 1254,
	"./editar-gray.svg": 62,
	"./editar.svg": 174,
	"./empty-search.png": 1255,
	"./febraban/login-illustra.png": 1256,
	"./febraban/tela_login_sm.png": 1257,
	"./fechar-menu-mobile.svg": 1258,
	"./fechar-menu-mobile_custom.svg": 1259,
	"./fechar-modal.svg": 288,
	"./fecharCinza.svg": 1260,
	"./fecharLegis.svg": 1261,
	"./filtar.png": 92,
	"./filtrar.svg": 1262,
	"./filtroProp.svg": 460,
	"./fone-discurso.svg": 1263,
	"./graficos_febraban.svg": 1264,
	"./ia-icon.svg": 202,
	"./iaMenu.svg": 1265,
	"./icon-search.png": 175,
	"./icone-acoes-relatorio.svg": 286,
	"./icone-menu-insights.svg": 1266,
	"./icone-menu-relatorio.svg": 1267,
	"./icone-parlamentar-relatorio.svg": 148,
	"./icone-proposicao-relatorio.svg": 134,
	"./icone_sucesso.svg": 203,
	"./img_153157.png": 1268,
	"./importar.png": 457,
	"./impressora.svg": 51,
	"./internal-action-small.svg": 1269,
	"./joined-small.svg": 291,
	"./like.svg": 1270,
	"./link-externo.svg": 1271,
	"./lixo-icon.svg": 1272,
	"./loader-button.gif": 1273,
	"./loading.gif": 1274,
	"./loading.svg": 281,
	"./login-illustra.png": 1275,
	"./logo-bradesco.svg": 1276,
	"./logo-menu-branco.png": 1277,
	"./logo-menu.svg": 1278,
	"./logo-relatorios-purpleClient.svg": 1279,
	"./logo_darkBlueClient.svg": 1280,
	"./logo_darkBlueClient_mobile.svg": 1281,
	"./logo_legisnote.svg": 1282,
	"./logo_login.png": 1283,
	"./logoutMenu.svg": 1284,
	"./lupa.svg": 172,
	"./lupa_buscar.svg": 285,
	"./manuParlamentaresIcon.svg": 383,
	"./menu-mobile.png": 1285,
	"./menuAgendaIcon.svg": 382,
	"./menuIaIcon.svg": 388,
	"./menuInsightIcon.svg": 386,
	"./menuMidiaNewsIcon.svg": 384,
	"./menuPerfilIcon.svg": 389,
	"./menuProposicoesIcon.svg": 381,
	"./menuRelatoriosIcon.svg": 385,
	"./midia-menu-mobile.svg": 1286,
	"./midia-news-mobile.svg": 1287,
	"./next-page-pagination.svg": 72,
	"./no-photo.png": 1288,
	"./no-photo.svg": 308,
	"./non-user-photo.jpg": 1289,
	"./noti-agenda.svg": 1290,
	"./noti-mencao.svg": 1291,
	"./noti-recomendada.svg": 1292,
	"./noti-update.svg": 1293,
	"./parlamentar-menu-mobile.svg": 1294,
	"./parlamentar.png": 1295,
	"./perfil-menu-mobile.svg": 1296,
	"./prev-page-pagination.svg": 71,
	"./proposicao-icone.svg": 1297,
	"./proposicao-menu-mobile.svg": 1298,
	"./proposicao-parlamentar.png": 456,
	"./purpleClient/IAicon.svg": 1299,
	"./purpleClient/clipsPreto.svg": 1300,
	"./purpleClient/iconTema.svg": 1301,
	"./purpleClient/link-externo-roxo.svg": 1302,
	"./purpleClient/logo-login-purpleClient.svg": 1303,
	"./purpleClient/logo_purpleClient.svg": 1304,
	"./purpleClient/sairNew.svg": 1305,
	"./purpleClient/seta-biografia-roxa.svg": 1306,
	"./purpleClient/userIcon.svg": 1307,
	"./relatorio-menu-mobile.svg": 1308,
	"./resetar-filtro.png": 173,
	"./sair-menu-mobile.svg": 390,
	"./salvar-propNova.svg": 463,
	"./send-red.svg": 1309,
	"./send.svg": 102,
	"./seta-direita.svg": 254,
	"./seta-selecionar.svg": 459,
	"./tela_login.png": 1310,
	"./tela_login_md.png": 1311,
	"./tela_login_sm.png": 1312,
	"./tela_login_xl.png": 1313,
	"./teste-botao-filtro.svg": 1314,
	"./timeline-acao-infl.svg": 1315,
	"./timeline-acao-prep.svg": 1316,
	"./timeline-active.svg": 1317,
	"./timeline-ativo.svg": 289,
	"./timeline-atual.svg": 1318,
	"./timeline-inactive.svg": 1319,
	"./timeline-inativo.svg": 1320,
	"./timeline-inicio.svg": 1321,
	"./timeline-pendente.svg": 290,
	"./trash-gray.svg": 43,
	"./trending.svg": 283,
	"./up-arrow.svg": 1322,
	"./userMenu.svg": 1323,
	"./video-discurso.svg": 1324,
	"./videoplay_icon.svg": 1325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1220;